<template>
  <v-dialog v-model="dialog" width="750" scrollable>
    <v-card flat>
      <v-toolbar color="primary" dark elevation="0">
        <v-toolbar-title>Kandidat Peserta</v-toolbar-title>
        <v-spacer />
        <v-btn text icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-container>
        <base-table-header @search="onSearch" @reload="onReload">
          <template v-slot:toolbar>
            <v-select
              class="mt-7"
              v-model="params.gelombang"
              :items="mGelombang"
              item-text="text"
              item-value="value"
              dense
              outlined
              @change="fetchData"
              style="max-width: 150px"
            />
          </template>
          <template v-slot:subtitle>
            <div class="my-auto subtitle-1 black--text"> {{ total }} Kandidat </div>
          </template>
        </base-table-header>
        <div style="min-height: 250px; max-height: 400px; overflow-y: auto">
          <base-list-table :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
            <template slot-scope="{ item }">
              <td>
                <v-card :disabled="item.penilai" flat class="ma-0">
                  <v-list two-line>
                    <v-list-item dense class="px-0">
                      <v-list-item-avatar class="mr-5">
                        <v-avatar color="orange">
                          <v-icon dark>mdi-bank</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-row>
                          <v-col cols="12" lg="5">
                            <span class="grey--text" style="font-size: 13px;"> Sekolah Penggerak </span>
                            <div class="info--text mt-1" style="font-size: 15px">
                              {{ $getDeepObj(item, 'sekolah.nama') || '-' }}
                            </div>
                            <div class="body-2">
                              <span class="font-weight-medium">NPSN: </span>
                              {{ $getDeepObj(item, 'sekolah.npsn') || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="12" lg="5">
                            <span class="grey--text" style="font-size: 13px;"> Kepala Sekolah </span>
                            <div class="font-weight-regular mt-1" style="font-size: 15px;">
                              <span class="font-weight-medium"> {{ $getDeepObj(item, 'ptk.nama') }} </span>
                              <div class="body-2">
                                <span class="font-weight-medium">No. UKG: </span> {{ $getDeepObj(item, 'ptk.no_ukg') }}
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" lg="2" class="my-auto">
                            <v-btn color="primary" depressed @click="onSelect(item)">Pilih</v-btn>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </td>
            </template>
          </base-list-table>
        </div>
        <v-divider />
        <div class="my-2">
          <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage" />
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import list from '@mixins/list';
import { mapActions } from 'vuex';
export default {
  mixins: [list],
  props: {
    meta: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
    };
  },
  computed: {
    mGelombang() {
      return (this.meta.gelombang_sumber || []).reverse().map((gelombang) => {
        return {
          text: `Angkatan ${gelombang}`,
          value: gelombang,
        };
      });
    },
  },
  methods: {
    ...mapActions('pkpSusulan', ['candidate']),

    fetchData() {
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});
      this.candidate({ params: params }).then((data) => {
        this.data = data.data || [];
        this.total = data?.total || 0;
        this.pageTotal = data?.last_page || 1;
        this.params.limit = data?.per_page || this.params.limit;
      });
    },

    open() {
      this.dialog = true;
      this.params.gelombang = [...[], ...(this.meta.gelombang_sumber || [])].pop();
      this.fetchData();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    renderSelect(item) {
      return [
        '<div class="black--text" style="font-size: 15px">Apakah Anda yakin ingin menambahkan data berikut menjadi peserta diklat?</div>',
        '<div class="mt-2 pa-3 grey lighten-3 black--text">',
        '<div class="v-list-item__content pa-2 white">',
        '<div class="row">',
        '<div class="col-lg-6 col-12">',
        '<span class="grey--text" style="font-size: 13px;"> Sekolah Penggerak </span>',
        `<div class="info--text mt-1" style="font-size: 15px;">${this.$getDeepObj(item, 'sekolah.nama') || ''}</div>`,
        `<div class="body-2"><span class="font-weight-medium">NPSN: </span> ${this.$getDeepObj(item, 'sekolah.npsn') ||
          ''}</div></div>`,
        '<div class="col-lg-6 col-12">',
        '<span class="grey--text" style="font-size: 13px;"> Kepala Sekolah </span>',
        '<div class="font-weight-regular mt-1" style="font-size: 15px;">',
        `<span class="font-weight-medium"> ${this.$getDeepObj(item, 'ptk.nama') || ''} </span>`,
        `<div class="body-2"><span className="font-weight-medium">No. UKG: </span> ${this.$getDeepObj(
          item,
          'ptk.no_ukg'
        )}</div>`,
        '</div>',
        '</div>',
        '</div>',
        '</div>',
        '</div>',
      ].join('');
    },

    onSelect(item) {
      this.$confirm(this.renderSelect(item), 'Konfirmasi tambah peserta', {
        tipe: 'error',
      }).then(() => {
        this.resolve(item);
        this.dialog = false;
      });
    },
  },
};
</script>
